export var CURRENT_SELECTION = '.';
export var PRIMARY_STORY = '^';